import { publicBuyerLoanOfficersHooks } from 'reducers/slices/public/buyer/loanOfficersSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficerCreditCard = () => {
  const { loanOfficers, loadLoanOfficers, loadMoreLoanOfficers, loadLoanOfficer } = publicBuyerLoanOfficersHooks.use();

  return {
    isLoanOfficersLoading: useFetchStatus(loanOfficers.loadingStatus).isPending,
    isLoanOfficersIdle: useFetchStatus(loanOfficers.loadingStatus).isIdle,
    loanOfficers: loanOfficers.items,
    meta: loanOfficers.meta,
    isLoanOfficersLoadingMore: useFetchStatus(loanOfficers.moreLoadingStatus).isPending,
    loadLoanOfficers,
    loadMoreLoanOfficers,
    loadLoanOfficer,
  };
};

export default useLoanOfficerCreditCard;



// WEBPACK FOOTER //
// ./src/reducers/hooks/public/buyer/useLoanOfficers.js